module.exports = __webpack_public_path__ + "static/img/popup_slate.62f0f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customer/duschking-configurator/shower_tray/popup_slate.png
// module id = 7cuN
// module chunks = 12